// extracted by mini-css-extract-plugin
module.exports = {"container":"Wizard_container__1tZMi","contentContainer":"Wizard_contentContainer__2Uw_F","paperTitle":"Wizard_paperTitle__mf2tx"};